import type { MetaData } from 'services/content/page/types/ArticlePage'
import type * as ArticleHeader from '../types/ArticleHeader'

export default function articleHeaderComponentParser(
  rawComponent: ArticleHeader.Raw,
  metaData: MetaData,
): ArticleHeader.Parsed {
  const { topicId, contentPublishDate, categoryLinks, cfdailyLinks } = metaData
  const props = rawComponent.articleHeader

  return {
    name: 'ArticleHeader',
    props: {
      topicId,
      date: contentPublishDate,
      cfdailyLinks,
      categoryLinks,
      ...props,
    },
  }
}

// // Removing bylineText here to ensure use of the componentString.
// const { bylineText, ...updatedProps } = PropParser.format(props)
// const {
//   contentPublishDate,
//   acf,
//   categories,
//   categoryLinks,
//   cfdailyLinks,
// } = entity
// const { topicId } = acf

// return [
//   {
//     name,
//     props: {
//       categories,
//       categoryLinks,
//       cfdailyLinks,
//       date: formatDate(parseDateString(contentPublishDate), 'yyyy-MM-dd'),
//       topicId,
//       ...updatedProps,
//     },
//   },
// ]
